import { render, staticRenderFns } from "./DcApprovalProcessApproved.vue?vue&type=template&id=77aa4758&scoped=true"
import script from "./DcApprovalProcessApproved.vue?vue&type=script&lang=js"
export * from "./DcApprovalProcessApproved.vue?vue&type=script&lang=js"
import style0 from "./DcApprovalProcessApproved.vue?vue&type=style&index=0&id=77aa4758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa4758",
  null
  
)

export default component.exports